export const UPDATE_RECENTLY_VIEWED = 'UPDATE_RECENTLY_VIEWED';
export const UPDATE_ISOPEN = 'UPDATE_ISOPEN';
